import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectHexes,
  selectInvalidPendingBuildings,
  selectPendingBuildings,
  selectPlayers,
  selectSpecialBuildings
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {validatePendingBuildings} from "../validatePendingBuildings";
import {setInvalidPendingBuildings, showToast} from "../../../redux/actions";

export const INVALID_PENDING_BUILDINGS_HEADERS = {
  // Игрок сам нажал «завершить фазу» (или план применился в начале хода)
  CLIENT: 'Новые строения размещены некорректно:',
  // Ход завершил серверный таймер
  SERVER: 'Вы некорректно разместили строения:',
};

// Строения, размещенные текущим игроком за этот ход строительства, против
// правил расположения (validatePendingBuildings) — те же аргументы, что берет
// кнопка завершения фазы
export const validateCurrentPlayerPendingBuildings = (state) => validatePendingBuildings(
  selectPendingBuildings(state),
  selectHexes(state),
  selectCurrentPlayer(state),
  selectPlayers(state),
  selectCitiesCache(state),
  selectBuildingsDamage(state),
  selectSpecialBuildings(state),
);

// Текст тоста о невалидных строениях: заголовок и уникальные ошибки списком
export const buildInvalidPendingBuildingsMessage = (validationResult, header) => {
  const errorMessages = [header];
  validationResult.invalidBuildings.forEach((invalidBuilding) => {
    invalidBuilding.validationErrors.forEach((error) => {
      if (!errorMessages.includes(error)) {
        errorMessages.push(error);
      }
    });
  });
  return errorMessages.join('\n• ');
};

/**
 * Проверить строения хода текущего игрока и подсветить невалидные — ровно как
 * кнопка завершения фазы строительства (красные молотки и тот же текст
 * ошибок), но БЕЗ завершения фазы. Только для клиента: на сервере путь
 * завершения хода свой (handleCompleteTurn).
 *
 * Список невалидных ячеек заменяется целиком: он не сбрасывается между ходами
 * сам, и устаревшие ключи чужого хода иначе дали бы красный молоток на новом
 * строении ([] отправляется, только если там что-то осталось).
 *
 * showToast: false — не показывать тост, а вернуть его текст (message),
 * например чтобы собрать один общий тост с другими сообщениями.
 * Возвращает {validationResult, message} (message — null, если все валидно).
 */
export const highlightInvalidPendingBuildings = (store, {showToast: shouldShowToast = true} = {}) => {
  const state = store.getState();
  const validationResult = validateCurrentPlayerPendingBuildings(state);

  if (validationResult.isValid) {
    if ((selectInvalidPendingBuildings(state) || []).length > 0) {
      store.dispatch(setInvalidPendingBuildings([]));
    }
    return {validationResult, message: null};
  }

  store.dispatch(setInvalidPendingBuildings(validationResult.invalidBuildings.map((building) => building.hexKey)));
  const message = buildInvalidPendingBuildingsMessage(validationResult, INVALID_PENDING_BUILDINGS_HEADERS.CLIENT);
  if (shouldShowToast) {
    store.dispatch(showToast(message, 'warning', 5000));
  }
  return {validationResult, message};
};
